
import Vue from "vue"
import ProjectItem from "@/components/project/projectItem.vue";
import { ProjectApi } from "@/api";
import LayOut from '@/components/layout/index.vue'
import Pagination from '@/components/pagination/index.vue'
import { createMainScrollerControl, createRequestMixins, createToTopControl } from "@/mixins";
import { IDetailArticle } from "blog";
import { i18n } from "@/plugins/i18n";

const PAGESIZE = 10

export default Vue.extend({
	data() {
		return {
			paginationData: {
				total: 0,
				current: 1,
				pageSize: 10
			},
		}
	},
	components: {
		ProjectItem,
		LayOut,
		Pagination
	},
	mixins: [createRequestMixins({
		key: 'projectList' as 'projectList',
		defaultValue: [] as IDetailArticle[]
	}),
	createToTopControl({
		refName: "projectContent",
	}),
	createMainScrollerControl({
		refName: "projectContent"
	})
	],

	created() {

	},
	methods: {
		getProjectList() {
			this.projectListLoading = true
			ProjectApi.getProjects({ ...this.routeInfo, type: i18n.locale }).then(v => {
				if (v && v.data) {
					this.projectList = v.data.rows || []
					this.paginationData.total = v.data.total

				}
				console.log(this.projectList, this.paginationData);

			}).finally(() => {
				this.projectListLoading = false
			})
		},
		toDetailPage(id: string) {
			this.$router.push({
				name: "projectDetail",
				params: {
					id
				}
			})
		},
		content2Top() {
			(this.$refs.projectContent as HTMLElement).scrollTop = 0
		},
	},
	computed: {
		routeInfo() {
			// console.log(this.$route.params, this.$route);
			const { page = 1, limit = PAGESIZE } = this.$route.query
			return {
				page: +page,
				limit: +limit
			}
		},
	},
	watch: {
		'paginationData.current': {
			handler(n) {
				this.content2Top()
				// console.log(this.$router.currentRoute);
				if (!/project*/.test(this.$router.currentRoute.name)) {
					return
				}
				if (this.$router.currentRoute.name === 'projectDetail') {
					return
				}
				const { page, limit } = this.routeInfo

				this.$router.push({
					name: 'projectIndex',
					query: {
						limit,
						page: n
					} as any
				})

			},
			deep: false,
			immediate: false
		},
		routeInfo(n, o) {
			if (!isRouteChange(n, o)) {
				return
			}
			const { page, limit } = this.routeInfo
			this.paginationData.current = page
			this.paginationData.pageSize = limit
			// console.log(this.routeInfo);
			// console.log(this.paginationData);

			this.getProjectList()

		},
		'$i18n.locale': {
			handler(n) {
				this.getProjectList()
			}
		}
	}

})
function isRouteChange<T extends {
	id: number;
	page: number;
	limit: number;
}>(newInfo: T, oldInfo: T) {
	for (let i in newInfo) {
		if (newInfo[i] !== oldInfo[i]) {
			return true
		}
	}
	return false
}
